import { Stack } from '@mui/material'
import { useLocation } from 'react-router-dom';
import HomeDashboard from './HomeDashboard';
import NotificationPage from './notification/NotificationPage';


function MainHomePage() {

    const location : any = useLocation()
    function useQuery() {
        return new URLSearchParams(location.search);
    }
    
    let query = useQuery();
    let active_page = query.get('page')

    const switchPage = () => {
        if (active_page === 'notification') {
            return <NotificationPage/>
        } else {
            return <HomeDashboard/>
        }
    }
 
    return (
        <Stack>
            {switchPage()}
        </Stack>
    )
}

export default MainHomePage
